import { Calendar, Table } from 'lucide-react';
import { useExportICS, useExportCSV } from '@/hooks/useExport';
import type { EventCategory } from '@/lib/types';

interface ExportSectionProps {
  weddingId: string;
  tags: EventCategory[];
}

export function ExportSection({ weddingId, tags }: ExportSectionProps) {
  const exportICS = useExportICS(weddingId, tags);
  const exportCSV = useExportCSV(weddingId, tags);

  return (
    <div className="rounded-xl overflow-hidden" style={{ background: 'var(--color-surface)' }}>
      <button
        onClick={() => exportICS.mutate()}
        disabled={exportICS.isPending}
        className="w-full flex items-center gap-3 px-4 h-14 border-b text-left"
        style={{ borderColor: 'rgba(255,255,255,0.08)', background: 'transparent', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.08)', cursor: exportICS.isPending ? 'not-allowed' : 'pointer', opacity: exportICS.isPending ? 0.7 : 1, fontFamily: 'var(--font-body)' }}
      >
        <Calendar size={18} style={{ color: 'var(--color-primary)', flexShrink: 0 }} />
        <div className="flex-1">
          <p className="text-sm font-medium" style={{ color: 'var(--color-text)', margin: 0 }}>
            {exportICS.isPending ? 'Exporting…' : 'Export as .ics'}
          </p>
          <p className="text-xs" style={{ color: 'var(--color-text-muted)', margin: 0 }}>Import into Calendar app</p>
        </div>
      </button>
      <button
        onClick={() => exportCSV.mutate()}
        disabled={exportCSV.isPending}
        className="w-full flex items-center gap-3 px-4 h-14 text-left"
        style={{ background: 'transparent', border: 'none', cursor: exportCSV.isPending ? 'not-allowed' : 'pointer', opacity: exportCSV.isPending ? 0.7 : 1, fontFamily: 'var(--font-body)' }}
      >
        <Table size={18} style={{ color: 'var(--color-primary)', flexShrink: 0 }} />
        <div className="flex-1">
          <p className="text-sm font-medium" style={{ color: 'var(--color-text)', margin: 0 }}>
            {exportCSV.isPending ? 'Exporting…' : 'Export as .csv'}
          </p>
          <p className="text-xs" style={{ color: 'var(--color-text-muted)', margin: 0 }}>Open in spreadsheet</p>
        </div>
      </button>
    </div>
  );
}
